import React from "react";
import { FormGroup, Radio, RadioGroup } from "@blueprintjs/core";
import css from "./styles.module.scss";

interface IRadioOption {
  value: string;
  label: string;
}

interface IRadioFilterGroupProps {
  label: string;
  selectedValue?: boolean;
  disabled: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  options?: IRadioOption[];
}

const RadioFilterGroup: React.FC<IRadioFilterGroupProps> = ({
  label,
  selectedValue,
  disabled,
  onChange,
  options = [
    { value: "", label: "Any" },
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ]
}) => {
  const getValue = () => {
    if (selectedValue === true) return "1";
    if (selectedValue === false) return "0";
    return "";
  };

  return (
    <FormGroup className="column is-one-fifth">
      <div className={css.formGroupLabel}>{label}</div>
      <RadioGroup
        disabled={disabled}
        selectedValue={getValue()}
        onChange={onChange}>
        {options.map(option => (
          <Radio key={option.value} value={option.value}>{option.label}</Radio>
        ))}
      </RadioGroup>
    </FormGroup>
  );
};

export default RadioFilterGroup;
